import { render, staticRenderFns } from "./labelSelect.vue?vue&type=template&id=1d74aa87&scoped=true"
import script from "./labelSelect.vue?vue&type=script&lang=js"
export * from "./labelSelect.vue?vue&type=script&lang=js"
import style0 from "./labelSelect.vue?vue&type=style&index=0&id=1d74aa87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d74aa87",
  null
  
)

export default component.exports